export default {
	"RecommendGoods.rise": "起",
	"RecommendGoods.purchase": "购买"
}